import { mergeSavedDetils } from "../../utils/editorHelpers";

// Everything about the detils of the audit (the auditkendaraandetil): checklist rows and markings.
const useEditorDetilApi = ({
  uiContext,
  requestPost,
  requestDelete,
  pengecekanSaved,
  setPengecekanSaved,
  setPengecekanDetilData,
}) => {
  // saves the rows of one checklist card
  const saveCekDetil = async ({ detils }) => {
    if (!detils || detils.length === 0) return;

    requestPost({
      fullUrl: "/api/audit/auditkendaraandetil/savemany",
      body: detils,
      isForm: false,
      onError: ({ message }) => {
        uiContext.showErrorMsg("Error", message);
      },
      onSuccess: ({ data, message }) => {
        uiContext.showSuccessMsg("Success", message);

        if (data) {
          setPengecekanDetilData((list) => mergeSavedDetils(list, detils, data));
        }

        // mark this label_grup as saved
        setPengecekanSaved({
          ...pengecekanSaved,
          [detils[0].label_grup]: true,
        });
      },
    });
  };

  const deleteDetil = async ({ id }) => {
    if (!id) return;

    requestDelete({
      fullUrl: `/api/audit/auditkendaraandetil/delete`,
      ids: [id],
      onError: ({ message }) => {
        uiContext.showErrorMsg("Error", message);
      },
      onSuccess: ({ message }) => {
        uiContext.showSuccessMsg("Success", message);
        setPengecekanDetilData((list) =>
          list.filter((detil) => detil.id !== id)
        );
      },
    });
  };

  // saves the rows of one photo card (the markings, including the ones staged by Beri Tanda) or of one edited row
  const saveDetilMany = async ({ pengecekanDetilData }) => {
    if (!pengecekanDetilData || pengecekanDetilData.length === 0) return;

    // _localId only stages a marking added with Beri Tanda before it is saved (see useEditorMarking.js);
    // the backend doesn't know it, so it's stripped from the actual request body
    const body = pengecekanDetilData.map(({ _localId, ...rest }) => rest);

    requestPost({
      fullUrl: "/api/audit/auditkendaraandetil/savemany",
      body,
      isForm: false,
      onError: ({ message }) => {
        uiContext.showErrorMsg("Error", message);
      },
      onSuccess: ({ data, message }) => {
        uiContext.showSuccessMsg("Success", message);

        if (data) {
          setPengecekanDetilData((list) =>
            mergeSavedDetils(list, pengecekanDetilData, data)
          );
        }
      },
    });
  };

  // handle UI event section

  const handleOnClickSaveCheckList = ({ detils }) => {
    saveCekDetil({ detils });
  };

  const handleOnClickSaveMarkingList = async ({ pengecekanDetilData }) => {
    saveDetilMany({ pengecekanDetilData });
  };

  return {
    saveCekDetil,
    deleteDetil,
    saveDetilMany,
    handleOnClickSaveCheckList,
    handleOnClickSaveMarkingList,
  };
};

export default useEditorDetilApi;
